var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-slick/~/enquire.js/src/index.js
 ** module id = 1096
 ** module chunks = 0
 **/